export enum NEXT_STEP_AFTER_VERIFY {
    new_password = 'NEW_PASSWORD',
    completeProfile = 'COMPLETE_PROFILE',
}